<template>
  <div class="myDatePickerBox">
    <el-date-picker
      v-model="valueData"
      style="width: 320px"
      type="daterange"
      size="medium"
      :clearable="false"
      :editable="false"
      :picker-options="pickerOptions"
      value-format="yyyy-MM-dd"
      @change="receiveMyDate"
      @focus="pickerBlur"
      range-separator="至"
      start-placeholder="开始日期"
      popper-class="custom-date-picker"
      end-placeholder="结束日期"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "myDatePicker",
  props: ["scopeDate"],
  data() {
    return {
      valueData: [],
      pickerKey: "0",
    };
  },
  watch: {
    scopeDate: {
      handler(to) {
        this.valueData = to;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        shortcuts: [
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近7日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近14日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 13);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate(time) {
          if (_this.pickerKey !== "0") {
            const times = 86400000 * 31;
            let curSelectTime = new Date(_this.minDate).getTime();
            let before = curSelectTime - times;
            let after = curSelectTime + times;
            return time.getTime() > after || time.getTime() < before;
          }
        },
        onPick({ maxDate, minDate }) {
          if (!maxDate) {
            _this.minDate = minDate;
            _this.pickerKey = "1";
          }
        },
      };
    },
  },
  methods: {
    pickerBlur() {
      this.pickerKey = "0";
    },
    receiveMyDate(date) {
      this.valueData[0] = date[0];
      this.valueData[1] = date[1];
      this.$emit("receiveMyDate", this.valueData);
    },
  },
};
</script>

<style lang="scss" scoped>
.myDatePickerBox {
  ::v-deep .el-range-separator {
    width: 30px;
  }
}
</style>